import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LiveNursesService } from 'src/app/recruiting/candidates/live-nurses-new/live-nurses.service';
import * as actions from 'src/app/recruiting/candidates/live-nurses-new/store/live-nurses.actions';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Injectable()
export class JobOptionsEffect {
    getJobOptions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadJobOptions),
            switchMap((action) => {
                return this.liveNursesService.getJobOptions(action.submittalIds).pipe(
                    map((response) =>
                        actions.loadJobOptionsSuccess({
                            submittalIds: action.submittalIds,
                            jobOptions: response
                        })
                    ),
                    catchError((error) => of(actions.loadJobOptionsFail({ error })))
                );
            })
        )
    );

    getJobOptionsFail$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(actions.loadJobOptionsFail),
                tap((action) => {
                    console.log(action.error);
                    this.toaster.toast('Sorry. A problem occurred while loading Job Options.');
                })
            ),
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        protected liveNursesService: LiveNursesService,
        private toaster: ToasterService
    ) {}
}
